import React, { useState, useEffect } from "react"
import { Col, Row } from "reactstrap"
import toast from "react-hot-toast"
import { useParams } from "react-router-dom"

import eyeIcon from "../../../assets/images/icons/eye-icon.svg"
import editIcon from "../../../assets/images/icons/edit-icon.svg"
import DeleteIcon from "assets/images/icons/finance-vendor-mang-del-icon.svg"

import ActiveInactiveSwitch from "../CommonUI/ActiveInactiveSwitch/ActiveInactiveSwitch"
import { DataTable } from "../../../components/DataTable"
import { useLocalPaginatedRequest } from "../../../hooks/useLocalPaginatedRequest"
import { DragDropContext, Droppable } from "react-beautiful-dnd"
import {
   DeleteTrailerBaseFeatureCategoryItem,
   GetTrailerBaseFeatureCategoryItemsListing,
   UpdateTrailerBaseFeatureCategoryItems,
   UpdateTrailerBaseFeatureSubTypeSequence,
   GetTrailersDetails,
} from "../../../api/api.service"
import { SearchBox } from "../../../components/SearchBox"
import { Button } from "../../../components/Button"
import { AutoComplete } from "../../../components/AutoComplete"
import { TrailerStatus } from "../../../constants"
import { convertToSelectOptions, withOrderSaveGuard } from "../../../utils/commonUtils"
import ManageBaseFeaturesCategoryItems from "./ManageBaseFeaturesCategoryItems"
import { convertDateTime, dateTimeFormat } from "utils/dateFormatUtils"
import DeleteModal from "../CommonUI/Modal/DeleteModal"
import autoCompleteStyles from "components/AutoComplete/autoCompleteStyles"
import TruncatedTextWithTooltip from "components/CustomTooltip/CustomTooltip"
const COLUMNS = {
   ITEM_NAME: "Item name",
   DATE_EDITED: "Date edited",
   STATUS: "Status",
   ACTIONS: "Actions",
}
const DATA_KEY = "data"
const TOTAL_KEY = "total"
const BaseFeaturesCategoryItems = ({}) => {
   const { trailerId, categoryId } = useParams()
   const [statusFilters, setStatusFilters] = useState(null)
   const [selection, setSelection] = useState({})
   const [openDelModal, setOpenDelModal] = useState(false)
   const {
      data,
      isFetching,
      searchText,
      handleSearchChange,
      request,
      setTableDataChangeLoading,
      tableDataChangeLoading,
      setData,
   } = useLocalPaginatedRequest({
      requestFn: GetTrailerBaseFeatureCategoryItemsListing,
      // customParams (rather than params) bypasses the hook's pagination, matching the
      // category-level page. Two reasons this has to load the whole category at once:
      // the sequence endpoint requires every non-deleted option in the payload, so a paginated
      // view could only ever submit a partial list; and `column: sequenceNo` is what makes the
      // saved drag order survive a refresh instead of falling back to `id desc`.
      customParams: {
         trailerId: Number(trailerId),
         categoryId: Number(categoryId),
         column: "sequenceNo",
         limit: -1,
         page: 1,
         ...(statusFilters?.value && { status: statusFilters?.value }),
      },
      deps: [statusFilters],
      dataKey: DATA_KEY,
      totalKey: TOTAL_KEY,
   })

   // The custom-order flag is trailer-wide, so option reordering is locked unless the trailer is in
   // custom order — same as the category level. The flag isn't on the option listing, so it is read
   // from the trailer.
   const [orderCustomized, setOrderCustomized] = useState(false)
   useEffect(() => {
      let cancelled = false
      GetTrailersDetails(trailerId)
         .then(res => {
            if (!cancelled) setOrderCustomized(Boolean(res?.orderCustomized))
         })
         .catch(() => {})
      return () => {
         cancelled = true
      }
   }, [trailerId])

   // Reorders the options inside this category. The whole category is loaded (see customParams
   // above), so the payload always covers every non-deleted option as the endpoint requires.
   const handleDragEnd = async result => {
      if (!orderCustomized) return
      if (statusFilters?.value) return
      if (!result.destination) return
      if (result.destination.index === result.source.index) return

      const previous = Array.from(data)
      const items = Array.from(data)
      const [reorderedItem] = items.splice(result.source.index, 1)
      items.splice(result.destination.index, 0, reorderedItem)

      setData(items)

      const payload = {
         categoryId: Number(categoryId),
         sequenceItems: items.map((item, index) => ({
            id: Number(item.id),
            sequenceNo: index,
         })),
      }

      try {
         await withOrderSaveGuard(() => UpdateTrailerBaseFeatureSubTypeSequence(payload))
         toast.success("Sequence updated successfully!")
      } catch (err) {
         setData(previous)
         toast.error("Failed to update sequence")
      }
   }

   const [eventsType, setEventsType] = useState({
      isManage: null,
      isUpdate: null,
      isDetails: null,
   })

   const handleInitManage = obj => {
      setEventsType(prev => ({ ...prev, isManage: true }))
      setSelection(obj)
   }

   const handleInitViewDetails = obj => {
      setSelection(obj)
      setEventsType(prev => ({ ...prev, isDetails: true, isManage: true }))
   }

   const handleSelectStatusOption = option => {
      setStatusFilters(option)
   }

   const handleStatusChange = async (currStatus, id) => {
      let status =
         currStatus === TrailerStatus.Active
            ? TrailerStatus.Inactive
            : TrailerStatus.Active
      let dataClone = [...data]
      dataClone.map(el => {
         if (el?.id == id) el.status = status
      })
      setData(dataClone)
      let payload = {
         status: status,
      }
      try {
         setTableDataChangeLoading(true)
         let res = await UpdateTrailerBaseFeatureCategoryItems(id, payload)
         toast.success("Trailer status has been updated !")
      } catch (err) {
         toast.error(err.message)
         let dataClone = [...data]
         dataClone.map(el => {
            if (el?.id == id) el.status = currStatus
         })
         setData(dataClone)
      } finally {
         setTableDataChangeLoading(false)
      }
   }

   const handleInitDelete = obj => {
      setSelection(obj)
      setOpenDelModal(prev => !prev)
   }

   return (
      <>
         <div className="mb-3 trailer-container">
            <div className="d-flex align-items-center justify-content-between admin-inventory-management-general-inventory-responsiveness trailer-btn-container">
               <div />

               <Button
                  className={`header-button headerButtonResponsive`}
                  title="Add Item"
                  onClick={() => handleInitManage({})}
               />
            </div>
         </div>

         <div className="mb-3">
            <div className="d-flex align-items-center justify-content-between admin-inventory-management-general-inventory-responsiveness ">
               <div className="status-search-con wh-im-dpgi-status  me-2 ">
                  <AutoComplete
                     value={statusFilters}
                     isClearable
                     onChange={val => handleSelectStatusOption(val)}
                     isSearchable={false}
                     placeholder="Select status"
                     customStyles={autoCompleteStyles.STYLE_SIX}
                     classNamePrefix="status-header-search-admin"
                     options={convertToSelectOptions(TrailerStatus)}
                  />
               </div>
               <div className="ad-location-search-box">
                  <SearchBox
                     inputClasses="vendor-search-input input-search"
                     labelClass="d-none"
                     placeholder="Search"
                     searchIcon={true}
                     searchIconClass="vendor-table-search-icon"
                     conClass="vendor-table-search-inner-class"
                     searchText={searchText}
                     onChange={handleSearchChange}
                  />
               </div>
            </div>
         </div>
         <Row>
            <Col md={12}>
               <DragDropContext onDragEnd={handleDragEnd}>
                  <Droppable droppableId="droppable">
                     {provided => (
                        <div {...provided.droppableProps} ref={provided.innerRef}>
                           <DataTable
                              isDraggable={orderCustomized && !statusFilters?.value}
                              droppablePlaceholder={provided.placeholder}
                              data={data}
                              tableClasses="base-feature-category-table"
                              loading={isFetching}
                              // className="vendor-data-container mt-3"
                              config={[
                                 {
                                    title: COLUMNS.ITEM_NAME,
                                    className: "",
                                    render: data => {
                                       return <TruncatedTextWithTooltip text={data.name} />
                                    },
                                 },
                                 {
                                    title: COLUMNS.DATE_EDITED,
                                    className: "",
                                    render: data => {
                                       return convertDateTime({
                                          date: data.updatedAt,
                                          customFormat:
                                             dateTimeFormat.casitaCustomDateFormat,
                                          dateOnly: true,
                                       })
                                    },
                                 },
            
                                 {
                                    title: COLUMNS.STATUS,
                                    className: "",
                                    render: data => (
                                       <ActiveInactiveSwitch
                                          isDisable={tableDataChangeLoading}
                                          id={data.id}
                                          name={`${data.id}`}
                                          onChange={e =>
                                             handleStatusChange(data?.status, data?.id)
                                          }
                                          isChecked={data?.status == TrailerStatus.Active}
                                       />
                                    ),
                                 },
            
                                 {
                                    title: COLUMNS.ACTIONS,
            
                                    render: data => (
                                       <div className="d-flex gap-2 pointer">
                                          <img
                                             src={eyeIcon}
                                             onClick={() => handleInitViewDetails(data)}
                                          />
            
                                          <img
                                             src={editIcon}
                                             onClick={() => handleInitManage(data)}
                                          />
                                          <img
                                             src={DeleteIcon}
                                             onClick={() => handleInitDelete(data)}
                                          />
                                       </div>
                                    ),
                                 },
                              ]}
                           />
                        </div>
                     )}
                  </Droppable>
               </DragDropContext>
            </Col>
         </Row>

         <ManageBaseFeaturesCategoryItems
            isDetailView={eventsType.isDetails}
            isOpen={eventsType.isManage}
            id={selection?.id}
            onSuccess={request}
            onToggleModal={() => {
               setSelection({})
               setEventsType(prev => ({
                  ...prev,
                  isManage: false,
                  isDetails: false,
               }))
            }}
         />

         <DeleteModal
            isOpen={openDelModal}
            toggleFunction={setOpenDelModal}
            id={selection.id}
            apiFunction={DeleteTrailerBaseFeatureCategoryItem}
            title={"Base Feature Item"}
            requestFunction={request}
         />
      </>
   )
}

export default BaseFeaturesCategoryItems
